import { createContext } from "react";

const TypeContext = createContext({ type: {} });

export { TypeContext };
